


import React, { useState, useRef, useEffect } from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/student/dashboard/NotificationDropdown.css";

const notificationsData = [
  {
    id: 1,
    avatar: "https://i.pravatar.cc/40?img=12",
    title: "Donation Request Approved",
    desc: "Your request for textbook support has been approved.",
    time: "5m ago",
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/40?img=32",
    title: "Document Verified",
    desc: "Your identity document has been verified successfully.",
    time: "20m ago",
  },
  {
    id: 3,
    avatar: "https://i.pravatar.cc/40?img=45",
    title: "New Message from Admin",
    desc: "Please submit your latest fee slip for verification.",
    time: "1h ago",
  },
  {
    id: 4,
    avatar: "https://i.pravatar.cc/40?img=7",
    title: "Donation Request Rejected",
    desc: "Your request for stationery support was rejected. Check details.",
    time: "Yesterday",
  },
  {
    id: 5,
    avatar: "https://i.pravatar.cc/40?img=5",
    title: "Donation Received",
    desc: "You have received your requested support for scholarship.",
    time: "2 days ago",
  },
];

const NotificationDropdown = () => {
  const [open, setOpen] = useState(false);
  const [notifications] = useState(notificationsData);

  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const viewAll = () => {
    setOpen(false);
    navigate("/student/studentnotifications");
  };

  return (
    <div className="nsd-notification-wrapper" ref={ref}>
      <button
        className="nsd-bell-btn"
        onClick={() => setOpen(!open)}
      >
        <Bell size={24} />
        {notifications.length > 0 && (
          <span className="nsd-badge">{notifications.length}</span>
        )}
      </button>

      {open && (
        <div className="nsd-notification-card">
          <div className="nsd-notification-header">
            <span>Notifications</span>
          </div>

          <div className="nsd-notification-list">
            {notifications.map((note) => (
              <div
                key={note.id}
                className="nsd-notification-item"
              >
                <img
                  src={note.avatar}
                  alt="avatar"
                  className="nsd-notif-avatar"
                />
                <div className="nsd-notif-content">
                  <div className="nsd-notif-title">
                    {note.title}
                  </div>
                  {note.desc && (
                    <div className="nsd-notif-desc">
                      {note.desc}
                    </div>
                  )}
                </div>
                <div className="nsd-notif-time">
                  {note.time}
                </div>
              </div>
            ))}
          </div>

          <button
            className="nsd-view-all-btn"
            onClick={viewAll}
          >
            View All
          </button>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;




